let Brand = {
  black: '#000000',
  white: '#FFFFFF',
  coolGray: '#C2C2C2',
  red: '#EB3300',
  brightGray: '#F9F9F9',
  mint: '#D1E0D7'
}

Brand.cPrefix = function (hex) {
  return hex.replace ('#', '0x');
}


export default Brand;


// WEBPACK FOOTER //
// ./brand.js